import _ from "lodash";

const lodashFacade = Object.freeze(
    Object.keys(_).reduce((facade, key) => {
        const value = _[key];

        facade[key] = typeof value === "function" ? value.bind(_) : value;

        return facade;
    }, {})
);

const Plugin = {
    install(VueInstance) {
        if (this.installed) {
            return;
        }

        this.installed = true;

        if (VueInstance?.config?.globalProperties) {
            VueInstance.config.globalProperties.$_ = lodashFacade;
        }

        if (VueInstance?.prototype) {
            VueInstance.prototype.$_ = lodashFacade;
        }
    },
};

export default Plugin;
